<template>
    <c-form-label>
        <slot />
    </c-form-label>
</template>
<script setup>
import { CFormLabel } from '@coreui/vue-pro/dist/esm/components/form/index.js';
</script>
